import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { articlesAPI, uploadsAPI } from '../services/api';
import { useT } from '../services/i18n';
import { localizeArticle } from '../services/catalogI18n';

const ArticlesSection = () => {
  const { t, lang } = useT();
  const [articles, setArticles] = useState([]);
  useEffect(() => { articlesAPI.getAll().then(list => setArticles(list.slice(0, 3))).catch(() => {}); }, []);
  return (
    <section className="py-6 sm:py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
          {t('home.articles')}
        </h2>

        {/* Video tutorials placeholder */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-gray-900 rounded-lg p-6 text-white col-span-1 md:col-span-3 lg:col-span-1">
            <h3 className="font-semibold mb-2">{t('blog.video1')}</h3>
            <p className="text-sm text-gray-400 mb-3">03 Feb 2022</p>
            <div className="aspect-video bg-gray-800 rounded-lg flex items-center justify-center">
              <div className="w-16 h-16 bg-orange-500/80 rounded-full flex items-center justify-center cursor-pointer hover:bg-orange-500 transition-colors">
                <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-white border-b-8 border-b-transparent ml-1" style={{ borderLeftWidth: '14px' }}></div>
              </div>
            </div>
          </div>
          <div className="bg-gray-900 rounded-lg p-6 text-white hidden lg:block">
            <h3 className="font-semibold mb-2">{t('blog.video2')}</h3>
            <p className="text-sm text-gray-400 mb-3">19 Aug 2020</p>
            <div className="aspect-video bg-gray-800 rounded-lg flex items-center justify-center">
              <div className="w-16 h-16 bg-orange-500/80 rounded-full flex items-center justify-center cursor-pointer hover:bg-orange-500 transition-colors">
                <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-white border-b-8 border-b-transparent ml-1" style={{ borderLeftWidth: '14px' }}></div>
              </div>
            </div>
          </div>
          <div className="bg-gray-900 rounded-lg p-6 text-white hidden lg:block">
            <h3 className="font-semibold mb-2">{t('blog.video3')}</h3>
            <p className="text-sm text-gray-400 mb-3">09 Dec 2021</p>
            <div className="aspect-video bg-gray-800 rounded-lg flex items-center justify-center">
              <div className="w-16 h-16 bg-orange-500/80 rounded-full flex items-center justify-center cursor-pointer hover:bg-orange-500 transition-colors">
                <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-white border-b-8 border-b-transparent ml-1" style={{ borderLeftWidth: '14px' }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Articles */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map(raw => localizeArticle(raw, lang)).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer group"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={uploadsAPI.resolveUrl(article.image)}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-500 mb-2">{article.date}</p>
                <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-700">
                  {t('home.learnMore')}
                  <ArrowRight size={14} className="ml-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;
